import { Navigate } from "react-router-dom";

import { WELCOME_PATH } from "../../../../constants/env";
import { Loading } from "../../../../legacy/components/Loading";
import { useMobileOnboardingGuard } from "../hooks/useMobileOnboardingGuard";

export function MobileOnboardingGuard(): JSX.Element {
  const { isLogged, loading, error, onboardingPath } = useMobileOnboardingGuard();

  if (loading) {
    return <Loading />;
  }

  if (error !== null) {
    throw error;
  }

  if (!isLogged) {
    return <Navigate to={WELCOME_PATH} replace />;
  }

  return <Navigate to={onboardingPath} replace />;
}

export default MobileOnboardingGuard;
